import _ from 'underscore';
import { EventEmitter } from 'events';
import assign from 'object-assign';
import {normalize} from 'normalizr';
import NormalizedEmitter from "../NormalizedEmitter";
import {isPresent} from "../general";
// we need a deep extend function, eventually we 
// can drop jquery dependency
import $ from "jquery";

const CHANGE_EVENT = 'change';

export function createStore(spec) {
  let dataSnapshotDict = {};


  var store = assign({
    pluckIdsFromArray(array){
      if(_.isFunction(this.idAttribute)){
        return _(array).map(this.idAttribute);
      }
      else{
        return _(array).pluck(this.idAttribute);
      }
    },
    createDataSnapshot(tag){
      if(!isPresent(tag)){
        tag = _.uuid();
      }
      const sp = $.extend(true, {}, this.getData());
      dataSnapshotDict[tag] = sp;
      return sp;
    },
    hasDataSnapshots(){
      return !!this.getDataSnapshotsAsArray().length;
    },
    getDataSnapshotsAsArray(){
      return _(this.getDataSnapshots()).toArray();
    },
    getDataSnapshots(){
      return dataSnapshotDict;
    },
    getDataSnapshotViaTag(tag){
      return dataSnapshotDict[tag];
    },
    // getLatestDataSnapshot(){
    //   return dataSnapshots[dataSnapshots.length - 1];
    // },
    clearAllDataSnapshots(){
      dataSnapshotDict = {};
    },
    removeDataSnapshotViaTag(tag){
      return (delete dataSnapshotDict[tag]);
    },
    removeDataSnapshot(sp){
      const tag = _(dataSnapshots).findKey(_findKeyInDictViaSnapshot, sp);
      return this.removeDataSnapshotViaTag(tag);
    },
    hasDataChangesSinceSnapshotViaTag(tag, options={}){
      const id = options.id;
      let s1 = this.getData();
      let s2 = this.getDataSnapshotViaTag(tag);

      if(!_.isNull(id) && !_.isUndefined(id)){
        s1 = s1[id];
        s2 = s2[id];
      }

      return this.hasChanges(s1, s2, options);
    },

    hasChanges(s1, s2, {only, except}){
      if(only){
        s1 = _(s1).only(only);
        s2 = _(s2).only(only);
      }
      else if(except){
        s1 = _(s1).except(except);
        s2 = _(s2).except(except);
      }
      return !_.isEqual(s1, s2);
    },

    // General Data regarding store
    setGeneralFetchingStatus(val){
      this.getGeneral().fetching = val;
      this.emitEvent('general:changed', val);
    },
    isGeneralFetching(){
      return !!this.getGeneral().fetching;
    },

    updateGeneralAndEmit(newGeneral){
      _.extend(this.getGeneral(), newGeneral);
      this.emitEvent("general:changed", data);
    },

    // Data Specific Entity within store
    setDataFetchingStatus(id, val){
      const data = this.getDataViaId(id);
      data.fetching = val;
      this.emitObjectChange(allData);
    },
    isDataFetching(id){
      return !!this.getGeneral().fetching;
    },

    isDataFetchingSuccess(id){
      return !!this.getGeneral().fetchSuccess;
    },


    removeObjectsByIds(obj, ids=[]){
      if(ids.length){
        // capture objects that are being removed
        // before removing
        const deletedObjects = _(obj).pick(...ids);

        _(ids).each((id)=>{
          delete obj[id];
        });

        return deletedObjects;
      }
    },
    removeDataByIdsAndEmit(ids){
      this.removeObjectsByIdsAndEmit(this.getData(), ids);
    },
    removeObjectsByIdsAndEmit(obj, ids=[]){
      if(ids.length){
        const deletedObjects = this.removeObjectsByIds(obj, ids);
        this.emitEvent('remove', deletedObjects);
      }
    },
    setAttrsForIds(ids, attrs={}){
      const data = this.getData();
      _(ids).map((id)=>{
        const item = data[id];
        if(item){
          _.extend(item, attrs);
          this.emitObjectChange(item);
        }
      });
      this.emitEvent('change');
    },

    addObjectsAndEmit(object, data){
      if(data){
        // inplace extend as indicated above
        const dataAndId = {[data.id]: data};
        _.extend(object, dataAndId);
        this.emitEvent('add', data);
        return data;
      }
    },
    updateObjectAndEmit(id, newData){
      const allData = this.getData();
      const existingData = allData[id];
      allData[id] = {...existingData, ...newData};
      // emit a global/generic change that we can listen to
      this.emitEvent("change", allData[id]);
      return this.emitObjectChange(allData[id]);
    },
    // this function takes the given new object data: {whatever: "xyz"}
    // and updates ALL updates in the entire store with this data of key val pairs
	   updateAllObjectsAndEmit(newData){
      const allData = this.getData();
      //const existingData = allData[id];
      _(allData).mapObject((currData,id)=>{
  		  allData[id] = {...currData, ...newData};
  		  this.emitObjectChange(allData[id]);
  	  })
      // emit a global/generic change that we can listen to
      this.emitEvent("change", allData);
     },
     // this function takes multiple data points: {'dfdsd': {id: 'dfdsd', whatever: "nice"}, 'seww': {id: 'seww', whatever: "nice"}}
     // and updates just those items in the store
     updateObjectsAndEmit(multiData){
      const allData = this.getData();
      //const existingData = allData[id];
      _(multiData).mapObject((newData,id)=>{
        const oldData = allData[id] || {};
        allData[id] = {...oldData, ...newData};
        this.emitObjectChange(allData[id]);
      })
      // emit a global/generic change that we can listen to
      this.emitEvent("change", allData);
    },


    emitObjectChange(obj){
      this.emitEvent(`change:${obj.id}`, ...obj);
      return obj;
    },
    emitChange() {
      this.emit(CHANGE_EVENT, ...arguments);
    },
    emitEvent(key, ...data){
      this.emit(`${this.storeEventBaseKey}:${key}`, ...data);
    },
    bindListener(eventKey, callback) {
      this.on(eventKey, callback);
    },

    unbindListener(eventKey, callback) {
      this.removeListener(eventKey, callback);
    },
    addChangeListener(callback) {
      this.on(CHANGE_EVENT, callback);
    },

    removeChangeListener(callback) {
      this.removeListener(CHANGE_EVENT, callback);
    },
    getDataViaId(id){
      return this.getData()[id];
    },
    getDataViaIds(ids=[]){
      return _.chain(this.getData()).pick(...ids).values().value();
    },
    dataAsArray(){
      return _(this.getData()).values();
    },
    findWhere(attrs){
      return _(this.dataAsArray()).findWhere(attrs);
    },
    filter(){
      return _(this.dataAsArray()).filter(...arguments);
    },
    where(attrs){
      return _(this.dataAsArray()).where(attrs);
    },
    normalizeAndStoreData(initialData){
      if(!initialData){
        return;
      }
      if(this.getData && this.getDefaults && this.normalizr){
        const data = this.getData();
        const defaults = this.getDefaults();
        const curNormalizr = this.normalizr;
		    initialData = normalize(initialData, curNormalizr).entities;

        NormalizedEmitter.emit("normalized_data", initialData, {namespaced: true});
      }else{
        console.warn(`please define a getData and getDefaults function in all of your stores!`);
      }
    },
    mergeData(newData, options={}){
      if(options.namespaced){
        newData = newData[this.normalizrKey];
      }
      if(!newData){
        return;
      }
      const data = this.getData();
      const defaults = this.getDefaults();
      _.extend(data, newData);
      _(data).mapObject(this.setDefaults);
      this.emitEvent('change', data);
    },
    setDefaults(obj){
      _.defaults(obj, this.getDefaults());
    },
    bindListenersForSubsetOfDataViaIds(){
      this._handleListenersForSubsetOfDataViaIds(...[...arguments, "bindListener"]);
    },
    unbindListenersForSubsetOfDataViaIds(){
      this._handleListenersForSubsetOfDataViaIds(...[...arguments, "unbindListener"]);
    },
    _handleListenersForSubsetOfDataViaIds(ids, eventNamePrefix, cbFunc, funcStr){
      _.chain(this.getData()).pick(...ids).mapObject((item, id)=>{
        this[funcStr](`${eventNamePrefix}:${id}`, cbFunc);
      }).value();
    }

  }, spec, EventEmitter.prototype);


  _.each(store, function (val, key) {
    if (_.isFunction(val)) {
      store[key] = store[key].bind(store);
    }
  });

  NormalizedEmitter.on("normalized_data", store.mergeData);

  store.setMaxListeners(0);
  return store;
}


function _findKeyInDictViaSnapshot(sp, k){
  const origSp = this;
  return origSp === sp;
}





// WEBPACK FOOTER //
// ./src/utilities/storeUtils/index.js